import { useSettings } from '@wu/widget-core';
import { getLayoutObjFromName } from '../../helpers';
import { useImageLazyLoading } from '../lazy-loading';
import { Carousel } from './carousel/Carousel';
import { Masonry } from './masonry/Masonry';
import { Panoramic } from './panoramic/Panoramic';
import { Slider } from './slider/Slider';
import { Thumbnails } from './thumbnails/Thumbnails';

export const Layout = ({ mobile, tablet, images }) => {
  const { layout } = useSettings();

  const LayoutsObject = {
    masonry: Masonry,
    thumbnails: Thumbnails,
    panoramic: Panoramic,
    slider: Slider,
    carousel: Carousel
  }[getLayoutObjFromName(layout).type];

  const { handleChangeInVisibleImages } = useImageLazyLoading();

  return (
    <LayoutsObject
      mobile={mobile}
      tablet={tablet}
      images={images}
      reportVisibleImages={handleChangeInVisibleImages}
    />
  );
};
